import React, { useState, useEffect } from 'react';
import { Trophy, Settings, X, Check, Search, Star, StarOff } from 'lucide-react';
import API_URL from '../config/ApiUrl';
import { useTheme } from '../arrangement/ThemeContext';
const AchievementSelectionModal = ({ 
  isOpen, 
  onClose, 
  allAchievements, 
  displayedAchievements, 
  onSave,
  colors
}) => {
  console.log(allAchievements);
  console.log(displayedAchievements);
  const [selectedIds, setSelectedIds] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const MAX_DISPLAY = 6;

  useEffect(() => {
    if (isOpen) {
      setSelectedIds(displayedAchievements.map(a => a.id));
      setSearchTerm('');
    }
  }, [isOpen, displayedAchievements]);

  const filteredAchievements = allAchievements.filter(achievement =>
    achievement.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    achievement.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const completedAchievements = filteredAchievements.filter(a => a.progress === 100);
  const incompleteAchievements = filteredAchievements.filter(a => a.progress < 100);

  const handleToggleSelection = (achievementId) => {
    setSelectedIds(prev => {
      if (prev.includes(achievementId)) {
        // Always allow deselection
        return prev.filter(id => id !== achievementId);
      } else {
        // If we're at the limit, don't add (user needs to deselect first)
        if (prev.length >= MAX_DISPLAY) {
          return prev;
        }
        // Add the new selection
        return [...prev, achievementId];
      }
    });
  };

  const handleSave = () => {
    onSave(selectedIds);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div style={{
        background: '#1f2937',
        borderRadius: '16px',
        padding: '24px',
        maxWidth: '600px',
        width: '100%',
        maxHeight: '80vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        border: '2px solid #374151'
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px',
          paddingBottom: '16px',
          borderBottom: '1px solid #374151'
        }}>
          <div>
            <h2 style={{
              margin: 0,
              color: '#f9fafb',
              fontSize: '20px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <Trophy size={20} style={{ color: '#fbbf24' }} />
              Choose Display Achievements
            </h2>
            <p style={{
              margin: '4px 0 0 0',
              color: '#9ca3af',
              fontSize: '14px'
            }}>
              Select up to {MAX_DISPLAY} achievements to display on your profile ({selectedIds.length}/{MAX_DISPLAY})
              {selectedIds.length >= MAX_DISPLAY && (
                <span style={{ color: '#fbbf24', fontWeight: '500' }}>
                  {' '}• Deselect an achievement to choose a different one
                </span>
              )}
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: '#9ca3af',
              cursor: 'pointer',
              padding: '4px'
            }}
          >
            <X size={24} />
          </button>
        </div>

        {/* Search */}
        <div style={{
          marginBottom: '20px',
          position: 'relative'
        }}>
          <Search 
            size={16} 
            style={{
              position: 'absolute',
              left: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#9ca3af'
            }}
          />
          <input
            type="text"
            placeholder="Search achievements..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '92%',
              padding: '8px 12px 8px 36px',
              background: '#374151',
              border: '1px solid #4b5563',
              borderRadius: '8px',
              color: '#f9fafb',
              fontSize: '14px',
              outline: 'none'
            }}
          />
        </div>

        {/* Achievement List */}
        <div style={{
          flex: 1,
          overflowY: 'auto',
          marginBottom: '20px'
        }}>
          {/* Completed Achievements */}
          {completedAchievements.length > 0 && (
            <>
              <h3 style={{
                color: '#10b981',
                fontSize: '16px',
                fontWeight: '600',
                margin: '0 0 12px 0',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <Check size={16} />
                Completed ({completedAchievements.length})
              </h3>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                gap: '12px',
                marginBottom: '24px'
              }}>
                {completedAchievements.map((achievement) => {
                  const isSelected = selectedIds.includes(achievement.id);
                  const canSelect = !isSelected || selectedIds.length <= MAX_DISPLAY;
                  const atLimit = selectedIds.length >= MAX_DISPLAY;
                  
                  return (
                    <div
                      key={achievement.id}
                      onClick={() => handleToggleSelection(achievement.id)}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: '12px',
                        borderRadius: '12px',
                        background: isSelected 
                          ? 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)'
                          : '#374151',
                        border: '2px solid',
                        borderColor: isSelected ? '#fbbf24' : (atLimit && !isSelected ? '#ef4444' : '#4b5563'),
                        cursor: 'pointer',
                        position: 'relative',
                        transition: 'all 0.2s ease',
                        opacity: (!isSelected && atLimit) ? 0.5 : 1
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.02)';
                        if (isSelected) {
                          e.currentTarget.style.borderColor = '#f59e0b';
                        } else if (atLimit) {
                          e.currentTarget.style.borderColor = '#dc2626';
                        } else {
                          e.currentTarget.style.borderColor = '#6b7280';
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        if (isSelected) {
                          e.currentTarget.style.borderColor = '#fbbf24';
                        } else if (atLimit) {
                          e.currentTarget.style.borderColor = '#ef4444';
                        } else {
                          e.currentTarget.style.borderColor = '#4b5563';
                        }
                      }}
                    >
                      {/* Selection indicator */}
                      <div style={{
                        position: 'absolute',
                        top: '6px',
                        right: '6px'
                      }}>
                        {isSelected ? (
                          <Star size={16} style={{ color: '#f59e0b', fill: '#f59e0b' }} />
                        ) : (
                          <StarOff size={16} style={{ 
                            color: atLimit ? '#ef4444' : '#6b7280'
                          }} />
                        )}
                      </div>

                      {/* Limit indicator for unselected items */}
                      {!isSelected && atLimit && (
                        <div style={{
                          position: 'absolute',
                          top: '6px',
                          left: '6px',
                          fontSize: '10px',
                          color: '#ef4444',
                          fontWeight: '600'
                        }}>
                          !
                        </div>
                      )}

                      <span style={{ 
                        fontSize: '20px', 
                        marginBottom: '6px'
                      }}>
                        {achievement.icon || '🏆'}
                      </span>
                      
                      <span style={{
                        fontSize: '11px',
                        fontWeight: '600',
                        textAlign: 'center',
                        color: isSelected ? '#92400e' : '#f9fafb',
                        lineHeight: '1.2',
                        marginBottom: '4px'
                      }}>
                        {achievement.name}
                      </span>

                      <span style={{
                        fontSize: '9px',
                        color: isSelected ? '#a16207' : '#9ca3af',
                        textAlign: 'center',
                        lineHeight: '1.1'
                      }}>
                        {achievement.description}
                      </span>
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {/* Incomplete Achievements */}
          {incompleteAchievements.length > 0 && (
            <>
              <h3 style={{
                color: '#6b7280',
                fontSize: '16px',
                fontWeight: '600',
                margin: '0 0 12px 0',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <Trophy size={16} />
                In Progress ({incompleteAchievements.length})
              </h3>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                gap: '12px'
              }}>
                {incompleteAchievements.map((achievement) => (
                  <div
                    key={achievement.id}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      padding: '12px',
                      borderRadius: '12px',
                      background: '#374151',
                      border: '2px solid #4b5563',
                      opacity: 0.6,
                      position: 'relative'
                    }}
                  >
                    <span style={{ 
                      fontSize: '20px', 
                      marginBottom: '6px',
                      filter: 'grayscale(100%)'
                    }}>
                      {achievement.icon || '🏆'}
                    </span>
                    
                    <span style={{
                      fontSize: '11px',
                      fontWeight: '600',
                      textAlign: 'center',
                      color: '#9ca3af',
                      lineHeight: '1.2',
                      marginBottom: '4px'
                    }}>
                      {achievement.name}
                    </span>

                    <div style={{
                      fontSize: '9px',
                      color: '#fbbf24',
                      fontWeight: '500',
                      marginBottom: '2px'
                    }}>
                      {achievement.progress}% Complete
                    </div>

                    <span style={{
                      fontSize: '8px',
                      color: '#6b7280',
                      textAlign: 'center',
                      lineHeight: '1.1'
                    }}>
                      {achievement.description}
                    </span>
                  </div>
                ))}
              </div>
            </>
          )}

          {filteredAchievements.length === 0 && (
            <div style={{
              textAlign: 'center',
              padding: '40px 20px',
              color: '#6b7280'
            }}>
              <Trophy size={32} style={{ marginBottom: '12px', opacity: 0.5 }} />
              <p style={{ margin: 0, fontSize: '14px' }}>
                No achievements found matching "{searchTerm}"
              </p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: '16px',
          borderTop: '1px solid #374151'
        }}>
          <div style={{
            fontSize: '12px',
            color: '#9ca3af'
          }}>
            {selectedIds.length >= MAX_DISPLAY 
              ? 'Deselect an achievement to choose a different one'
              : 'Only completed achievements can be displayed on your profile'
            }
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={onClose}
              style={{
                background: '#4b5563',
                color: '#f9fafb',
                border: 'none',
                borderRadius: '8px',
                padding: '8px 16px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              style={{
                background: '#10b981',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '8px 16px',
                cursor: 'pointer',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}
            >
              <Check size={14} />
              Save Selection
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const AchievementsCard = ({ profileData, loading, onUpdateDisplayPreferences, isAuthenticated }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const displayedAchievements = profileData?.displayed_achievements || [];
  const allAchievements = profileData?.achievements || [];
  const totalCount = allAchievements.length;
  const { colors } = useTheme();
  const handleSaveSelection = async (selectedIds) => {
    try {
      const response = await fetch(`${API_URL}/api/achievements/display`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ selected_ids: selectedIds }),
      });
      
      if (!response.ok) {
        throw new Error('Failed to update achievement display');
      }
      
      console.log('Achievement display updated successfully');
    } catch (error) {
      console.error('Failed to update achievement display:', error);
      alert('Failed to update achievement display. Please try again.');
    }
  };

  // Show login prompt if user is not authenticated
  if (!isAuthenticated) {
    return (
      <div style={{
        background: colors.bgCard,
        borderRadius: '16px',
        padding: '20px',
        border: '2px solid #333',
        color: '#e5e5e5',
        marginBottom: '24px',
        position: 'relative'
      }}>
        <h3 style={{
          margin: '0 0 16px 0',
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          color: '#e5e5e5'
        }}>
          <Trophy size={18} style={{ color: '#fbbf24' }} />
          Achievements
        </h3>
        
        <div style={{
          textAlign: 'center',
          padding: '32px 16px',
          color: '#888'
        }}>
          <div style={{
            width: '64px',
            height: '64px',
            background: 'linear-gradient(135deg, #374151 0%, #4b5563 100%)',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px auto',
            border: '2px dashed #555'
          }}>
            <Trophy size={32} style={{ color: '#888', opacity: 0.5 }} />
          </div>
          
          <h4 style={{
            margin: '0 0 8px 0',
            fontSize: '16px',
            fontWeight: '600',
            color: '#e5e5e5'
          }}>
            Login to View Achievements
          </h4>
          
          <p style={{
            margin: '0 0 20px 0',
            fontSize: '14px',
            color: '#888',
            lineHeight: '1.4'
          }}>
            Sign in to unlock and track your achievements
          </p>
          
          <button
            onClick={() => window.location.href = '/login'} // Adjust to your login route
            style={{
              padding: '12px 24px',
              background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)';
            }}
          >
            Sign In
          </button>
        </div>
      </div>
    );
  }

  // Rest of the original component code for authenticated users
  return (
    <>
      <div 
        onClick={() => setIsModalOpen(true)}
        style={{
          background: colors.bgCard,
          borderRadius: '16px',
          padding: '20px',
          border: '2px solid #333',
          color: '#e5e5e5',
          marginBottom: '24px',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          position: 'relative'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = '#4b5563';
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.2)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = '#333';
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = 'none';
        }}
      >
        {/* Clickable indicator */}
        <div style={{
          position: 'absolute',
          top: '.1rem',
          right: '.1rem',
          borderRadius: '20px',
          padding: '6px 10px',
          fontSize: '10px',
          color: '#9ca3af',
          display: 'flex',
          alignItems: 'center',
          gap: '4px'
        }}>
          <Settings size={12} />
          Click to customize
        </div>

        <h3 style={{
          margin: '0 0 16px 0',
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          color: '#e5e5e5'
        }}>
          <Trophy size={18} style={{ color: '#fbbf24' }} />
          Achievements ({displayedAchievements.length}{totalCount > 6 ? ` of ${totalCount}` : ''})
        </h3>
        
        {displayedAchievements.length > 0 ? (
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(90px, 1fr))', 
            gap: '12px' 
          }}>
            {displayedAchievements.map((achievement, index) => (
              <div 
                key={achievement.id} 
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: '16px 12px',
                  borderRadius: '12px',
                  background: achievement.progress === 100 
                    ? 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)'
                    : 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
                  border: '1px solid',
                  borderColor: achievement.progress === 100 ? '#fbbf24' : '#4b5563',
                  opacity: achievement.progress === 100 ? 1 : 0.6,
                  transition: 'all 0.3s ease',
                  position: 'relative'
                }}
                title={achievement.description}
              >
                <span style={{ 
                  fontSize: '24px', 
                  marginBottom: '8px',
                  filter: achievement.progress === 100 ? 'none' : 'grayscale(100%)'
                }}>
                  {achievement.icon || '🏆'}
                </span>
                <span style={{
                  fontSize: '10px',
                  fontWeight: '600',
                  textAlign: 'center',
                  color: achievement.progress === 100 ? '#92400e' : '#e5e7eb',
                  lineHeight: '1.2'
                }}>
                  {achievement.name}
                </span>
                
                {achievement.progress < 100 && achievement.progress > 0 && (
                  <div style={{
                    marginTop: '4px',
                    fontSize: '8px',
                    color: '#fbbf24',
                    fontWeight: '500'
                  }}>
                    {achievement.progress}%
                  </div>
                )}
                
                {achievement.progress === 100 && (
                  <div style={{
                    position: 'absolute',
                    top: '4px',
                    right: '4px',
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: '#10b981'
                  }} />
                )}
              </div>
            ))}
          </div>
        ) : (
          <div style={{
            textAlign: 'center',
            padding: '24px 16px',
            color: '#888'
          }}>
            <Trophy size={32} style={{ marginBottom: '12px', opacity: 0.5 }} />
            <p style={{ margin: 0, fontSize: '14px' }}>
              No achievements selected for display
            </p>
            <p style={{ margin: '4px 0 0 0', fontSize: '12px' }}>
              {totalCount > 0 
                ? 'Click here to choose which achievements to show'
                : 'Keep participating to unlock achievements!'
              }
            </p>
          </div>
        )}
      </div>

      <AchievementSelectionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        allAchievements={allAchievements}
        displayedAchievements={displayedAchievements}
        onSave={handleSaveSelection}
        colors={colors}
      />
    </>
  );
};